// Реестр модулей клиентского портала.
// Зеркало backend/client/PortalModules.php: сервер уже не отдаёт данные выключенных
// модулей, здесь страховка для статичных контролов (вкладки, типы отчётов, права
// субпользователей, события трека) и единая точка, где описано, что кому принадлежит.
//
// Как добавить модуль: запись здесь + в PortalModules.php (+ backend/php/PortalModules.php),
// подпись в админке (availableModules + i18n clientDetails.modules.*). См. docs/CLIENT_MODULES.md.
//
// Поля модуля (все необязательные):
//   reportCodes      коды отчётов (ReportsPage, конструктор произвольных отчётов)
//   eventKinds       kind'ы событий трека (сравнение без учёта регистра)
//   prefTypes        типы матрицы каналов уведомлений (NotificationsPage)
//   inAppTypes       type in-app уведомлений (колокольчик)
//   notificationTabs вкладки страницы уведомлений
//   widgets          типы виджетов дашборда (библиотека виджетов)
//   deviceFields     поля устройства из GET /devices, которые обнуляются
//   permissions      права субпользователей, которые модуль выключает
//   hidePersonDevices персональные устройства принадлежат модулю
export const MODULES = {
  dashboard: {},
  reports: {},
  // SENT/e-TOLL: без модуля нет вкладки «E-TOLL» в уведомлениях, строки в матрицах каналов
  // и виджета «Баланс e-TOLL»
  regtech: {
    prefTypes: ['sent_etoll', 'sent_etoll_no_fix'],
    inAppTypes: ['sent_etoll_no_fix'],
    notificationTabs: ['etoll'],
    widgets: ['etoll-balance'],
    permissions: ['canViewRegtech', 'canEditRegtech'],
  },
  // Права на геозони належать модулю: вимкнений модуль ховає їх і у форми субкористувача
  geozones: { permissions: ['canViewGeozones', 'canEditGeozones'] },
  maintenance: {},
  drivers: { permissions: ['canViewDrivers', 'canEditDrivers'] },
  trailers: { permissions: ['canViewTrailers', 'canEditTrailers'] },
  subusers: {},
  sharing: {},
  // Генератори: блок «Генератор» у профілі приладу, електричні датчики лічильників AC
  // і право співробітника. Сервер гейтить /generators/* і ховає види датчиків
  generators: {
    reportCodes: ['generators'],
    prefTypes: ['generator_run', 'generator_fault', 'generator_overload', 'generator_idle', 'generator_stop_load'],
    inAppTypes: ['generator'],
    notificationTabs: ['generators'],
    eventKinds: [
      'GENERATOR_START', 'GENERATOR_STOP', 'GENERATOR_STOP_UNDER_LOAD', 'GENERATOR_NO_OUTPUT',
      'GENERATOR_PHASE_LOST', 'GENERATOR_OVERLOAD', 'GENERATOR_IMBALANCE', 'GENERATOR_IDLE_RUN',
    ],
    permissions: ['canSeeGenerators'],
  },
  personnel: {
    reportCodes: ['personnel-timesheet'],
    permissions: ['canViewPersonnel', 'canEditPersonnel'],
    hidePersonDevices: true,
  },
  tasks: {
    inAppTypes: ['task_edited'],
    permissions: ['canViewTasks', 'canEditTasks', 'canExecuteTasks'],
  },
  tacho: {
    reportCodes: ['tacho-activity'],
    eventKinds: [
      'TACHO_DRIVE_NO_CARD', 'TACHO_BREAK_DUE', 'TACHO_BREAK_REQUIRED', 'TACHO_DAILY_DUE',
      'TACHO_DAILY_LIMIT', 'TACHO_OVERSPEED', 'TACHO_CARD_IN', 'TACHO_CARD_OUT',
    ],
    prefTypes: ['tacho_no_card', 'tacho_break_due', 'tacho_break_required', 'tacho_daily_due', 'tacho_daily_limit'],
    inAppTypes: ['tacho'],
    notificationTabs: ['tacho'],
    deviceFields: ['tacho'],
  },
  // АЗС: сторінка /fuel-stations (роутер), сервер гейтить /station-cards/*; віджет «АЗС» працює і без модуля.
  // Сповіщення про приходи й порушення карток: вкладка «АЗС» на сторінці сповіщень, типи в дзвіночку
  stationcards: {
    // Заправки по картках: без модуля карток немає
    reportCodes: ['station-cards'],
    prefTypes: ['station_intake', 'station_over_limit', 'station_blocked', 'station_expired', 'station_not_allowed'],
    inAppTypes: ['station_card', 'station_intake'],
    notificationTabs: ['stations'],
  },
  // Відео з камер (JT/T 1078): кнопка «Відео» в картці машини. Сервер гейтить /devices/{id}/video*,
  // поле device.video (перелік каналів) без модуля не приходить; право співробітника окреме
  video: {
    permissions: ['canViewVideo'],
    deviceFields: ['video'],
  },
  dtc: {
    reportCodes: ['dtc-fleet'],
    eventKinds: ['DTC_NEW', 'DTC_CLEARED', 'DTC_CRITICAL', 'DTC_DERATE'],
    prefTypes: ['dtc'],
    inAppTypes: ['dtc'],
    deviceFields: ['dtc'],
  },
}

export const MODULE_KEYS = Object.keys(MODULES)

// Модуль, которому принадлежит право субпользователя (null = право вне модулей)
export function moduleForPermission(permissionKey) {
  for (const [key, scope] of Object.entries(MODULES)) {
    if ((scope.permissions || []).includes(permissionKey)) return key
  }
  return null
}

// Значения поля scope по списку выключенных модулей
export function collectHidden(disabledKeys, field) {
  const out = new Set()
  for (const key of disabledKeys) {
    for (const value of MODULES[key]?.[field] || []) out.add(value)
  }
  return out
}
